import {isNotNil} from 'ramda';

import {AvailableCar} from '../../../types/AvailableCar';
import {PriceReportType} from '../../../types/PriceReportType';
import {ExtendedStatisticsCar} from '../components/Chart/types/ExtendedStatisticsCar';

export function mapNeighboursToStatisticsCars(
  priceReport: PriceReportType,
  neighbours: AvailableCar[] | undefined
): ExtendedStatisticsCar[] {
  return (
    priceReport.neighborAdIds
      ?.map((id) => neighbours?.find((car) => car.ad_id === id))
      .filter((car): car is AvailableCar => isNotNil(car))
      .map((car) => ({
        ad_id: car.ad_id ?? '',
        days_on_stock: car.days_on_stock ?? 1,
        feature_score: car.feature_score ?? 0,
        is_available: true,
        is_sold: car.is_sold ?? false,
        first_occurrence: car.first_occurrence ?? priceReport.created,
        last_occurrence: car.last_occurrence ?? priceReport.created,
        mileage: car.mileage ?? 0,
        price_with_vat: car.price_with_vat ?? 0,
        original_price_with_vat: car.original_price_with_vat ?? 0,
        position: 0,
        isDebugVehicle: true,
      })) ?? []
  );
}
